import { render, staticRenderFns } from "./CsEmojiPicker.vue?vue&type=template&id=01e2df81&"
import script from "./CsEmojiPicker.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsEmojiPicker.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports